export default "__VITE_ASSET__ChbtHNfj__"